import { render, staticRenderFns } from "./PhotographyInfoComponent.vue?vue&type=template&id=2c867018&"
import script from "./PhotographyInfoComponent.ts?vue&type=script&lang=ts&"
export * from "./PhotographyInfoComponent.ts?vue&type=script&lang=ts&"
import style0 from "./PhotographyInfoComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports